import ReactTable from "components/lib/Shared/ReactTable";
import Tag from "components/lib/Shared/Tag";

function OfficialShareAllocation({
  official,
  tableData,
  isInChangesModule,
  sharesAllotted = [],
}) {
  const groupSharesAllotted = () => {
    return Object.values(
      sharesAllotted.reduce((acc, share) => {
        const key = share.classOfShares;

        if (!acc[key]) {
          acc[key] = {
            ...share,
            allottedShares: 0,
            paidUpShares: 0,
            sharesValue: 0,
            sharePremium: 0,
            nominalValue: 0,
          };
        }

        acc[key].allottedShares += share.allottedShares || 0;
        acc[key].paidUpShares += share.paidUpShares || 0;
        acc[key].sharesValue += share.sharesValue || 0;
        acc[key].sharePremium += share.sharePremium || 0;
        acc[key].nominalValue += share.nominalValue || 0;

        return acc;
      }, {})
    );
  };
  sharesAllotted = groupSharesAllotted();
  const officialShareAllocationColumns = [
    {
      Header: "Class of shares",
      Cell: ({ row }) => row.original.classOfShares,
    },
    { Header: "Number of Shares", accessor: "allottedShares" },
    {
      Header: "Value Of Shares",
      Cell: ({ row }) => (
        <div className="inline-flex items-baseline">
          <span className="px-1 text-xs font-medium">KES</span>{" "}
          <Tag>{row.original.sharesValue}</Tag>
        </div>
      ),
    },
    { Header: "Paid Up Shares", accessor: "paidUpShares" },
    {
      Header: "Premium Paid",
      Cell: ({ row }) => (
        <div className="inline-flex items-baseline">
          <span className="px-1 text-xs font-medium">KES</span>{" "}
          <Tag>{row.original.sharePremium}</Tag>
        </div>
      ),
    },
    {
      Header: "Nominal Value",
      Cell: ({ row }) => (
        <div className="inline-flex items-baseline">
          <span className="px-1 text-xs font-medium">KES</span>{" "}
          <Tag>{row.original.nominalValue}</Tag>
        </div>
      ),
    },
    {
      Header: "Voting Rights",
      Cell: ({ row }) => row.original.votingRights,
    },
  ];

  const proposedData = sharesAllotted.map((share) => {
    const shareholder = tableData.find((item) => item._id);
    const additionalSharesAllotted = shareholder?.additionalSharesAllotted || 0;
    const premiumPerShare = shareholder?.premiumPerShare || 0;
    const sharesValue = share.sharesValue || 0;
    // Fetch classOfShares from tableData, either directly or from sharesAllotted[0]
    const classOfShares =
      shareholder?.classOfShares ||
      shareholder?.sharesAllotted?.[0]?.classOfShares ||
      "N/A";

    return {
      classOfShares: classOfShares,
      allottedShares: additionalSharesAllotted,
      sharesValue: share.sharesValue,
      paidUpShares: "-",
      sharePremium: premiumPerShare * additionalSharesAllotted,
      nominalValue: additionalSharesAllotted * sharesValue,
      votingRights: share.votingRights,
    };
  });

  if (isInChangesModule) {
    return (
      <>
        <div className="w-full bg-white p-2 shadow">
          <h3 className="mt-2 text-md font-medium text-sflPrimary">
            Current Allocation
          </h3>
          <div className="w-full overflow-x-auto mt-4">
            <ReactTable
              columns={officialShareAllocationColumns}
              data={sharesAllotted}
            />
          </div>
        </div>
        <div className="w-full mt-6 p-2 bg-white shadow">
          <h3 className="mt-2 text-md font-medium text-sflPrimary">
            Proposed Allocation
          </h3>
          <div className="w-full overflow-x-auto mt-4">
            <ReactTable
              columns={officialShareAllocationColumns}
              data={proposedData}
            />
          </div>
        </div>
        {sharesAllotted.length === 0 && proposedData.length === 0 && (
          <p className="mt-4 text-center">No data available</p>
        )}
      </>
    );
  }

  return (
    <>
      {sharesAllotted.length > 0 ? (
        <div className="w-full bg-white shadow">
          <div className="w-full overflow-x-auto mt-4">
            <ReactTable
              columns={officialShareAllocationColumns}
              data={sharesAllotted}
            />
          </div>
        </div>
      ) : (
        <p className="mt-4 text-center">No data available</p>
      )}
    </>
  );
}

export default OfficialShareAllocation;
